import { __module as u } from "./chunk682.js";
import { __require as R } from "./chunk447.js";
import { __require as x } from "./chunk451.js";
import { __require as g } from "./chunk453.js";
import { __require as S } from "./chunk463.js";
import { __require as k } from "./chunk464.js";
var y = u.exports, h;
function j() {
  return h ? u.exports : (h = 1, function(m, B) {
    (function(f, a, n) {
      m.exports = a(R(), x(), g(), S(), k());
    })(y, function(f) {
      return function() {
        var a = f, n = a.lib, v = n.StreamCipher, c = a.algo, _ = c.RC4 = v.extend({
          _doReset: function() {
            for (var r = this._key, i = r.words, t = r.sigBytes, o = this._S = [], e = 0; e < 256; e++)
              o[e] = e;
            for (var e = 0, s = 0; e < 256; e++) {
              var d = e % t, C = i[d >>> 2] >>> 24 - d % 4 * 8 & 255;
              s = (s + o[e] + C) % 256;
              var q = o[e];
              o[e] = o[s], o[s] = q;
            }
            this._i = this._j = 0;
          },
          _doProcessBlock: function(r, i) {
            r[i] ^= p.call(this);
          },
          keySize: 256 / 32,
          ivSize: 0
        });
        function p() {
          for (var r = this._S, i = this._i, t = this._j, o = 0, e = 0; e < 4; e++) {
            i = (i + 1) % 256, t = (t + r[i]) % 256;
            var s = r[i];
            r[i] = r[t], r[t] = s, o |= r[(r[i] + r[t]) % 256] << 24 - e * 8;
          }
          return this._i = i, this._j = t, o;
        }
        a.RC4 = v._createHelper(_);
        var l = c.RC4Drop = _.extend({
          /**
           * Configuration options.
           *
           * @property {number} drop The number of keystream words to drop. Default 192
           */
          cfg: _.cfg.extend({
            drop: 192
          }),
          _doReset: function() {
            _._doReset.call(this);
            for (var r = this.cfg.drop; r > 0; r--)
              p.call(this);
          }
        });
        a.RC4Drop = v._createHelper(l);
      }(), f.RC4;
    });
  }(u), u.exports);
}
export {
  j as __require
};
